/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as WorkspaceRouteRouteImport } from "./routes/$workspace/route";
import { Route as AdminRouteRouteImport } from "./routes/admin/route";
import { Route as DesignRouteImport } from "./routes/design";
import { Route as DeviceRouteImport } from "./routes/device";
import { Route as LoginRouteImport } from "./routes/login";
import { Route as SignupRouteImport } from "./routes/signup";
import { Route as WorkspaceIndexRouteImport } from "./routes/$workspace/index";
import { Route as WorkspaceProjectRouteRouteImport } from "./routes/$workspace/$project/route";
import { Route as WorkspaceAccountRouteImport } from "./routes/$workspace/account";
import { Route as WorkspaceNewRouteImport } from "./routes/$workspace/new";
import { Route as WorkspaceSettingsRouteImport } from "./routes/$workspace/settings";
import { Route as WorkspaceSpendRouteImport } from "./routes/$workspace/spend";
import { Route as AdminIndexRouteImport } from "./routes/admin/index";
import { Route as AdminAiOpsRouteImport } from "./routes/admin/ai-ops";
import { Route as AdminIncidentsRouteImport } from "./routes/admin/incidents";
import { Route as AdminMoneyRouteImport } from "./routes/admin/money";
import { Route as AdminOperationsRouteImport } from "./routes/admin/operations";
import { Route as AdminSignupsRouteImport } from "./routes/admin/signups";
import { Route as AdminUsageRouteImport } from "./routes/admin/usage";
import { Route as ApproveApprovalIdRouteImport } from "./routes/approve/$approvalId";
import { Route as BadgeProjectRouteImport } from "./routes/badge/$project";
import { Route as DbAccessGrantIdRouteImport } from "./routes/db-access/$grantId";
import { Route as GithubCallbackRouteImport } from "./routes/github/callback";
import { Route as InvitationsAcceptRouteImport } from "./routes/invitations/accept";
import { Route as InviteCodeRouteImport } from "./routes/invite/$code";
import { Route as WaitlistConfirmRouteImport } from "./routes/waitlist/confirm";
import { Route as WorkspaceProjectIndexRouteImport } from "./routes/$workspace/$project/index";
import { Route as WorkspaceProjectAgentsRouteImport } from "./routes/$workspace/$project/agents";
import { Route as WorkspaceProjectComplianceRouteImport } from "./routes/$workspace/$project/compliance";
import { Route as WorkspaceProjectLogsRouteImport } from "./routes/$workspace/$project/logs";
import { Route as WorkspaceProjectMetricsRouteImport } from "./routes/$workspace/$project/metrics";
import { Route as WorkspaceProjectSafetyRouteImport } from "./routes/$workspace/$project/safety";
import { Route as WorkspaceProjectSettingsRouteRouteImport } from "./routes/$workspace/$project/settings/route";
import { Route as WorkspaceProjectSpendRouteImport } from "./routes/$workspace/$project/spend";
import { Route as AdminAccountsIndexRouteImport } from "./routes/admin/accounts/index";
import { Route as AdminAccountsUserIdRouteImport } from "./routes/admin/accounts/$userId";
import { Route as AdminServersIndexRouteImport } from "./routes/admin/servers/index";
import { Route as AdminServersNodeRouteImport } from "./routes/admin/servers/$node";
import { Route as AdminTenantsIndexRouteImport } from "./routes/admin/tenants/index";
import { Route as AdminTenantsWorkspaceIdRouteImport } from "./routes/admin/tenants/$workspaceId";
import { Route as WorkspaceProjectDeploymentsIndexRouteImport } from "./routes/$workspace/$project/deployments/index";
import { Route as WorkspaceProjectDeploymentsDeploymentIdRouteImport } from "./routes/$workspace/$project/deployments/$deploymentId";
import { Route as WorkspaceProjectDomainsDomainRouteImport } from "./routes/$workspace/$project/domains/$domain";
import { Route as WorkspaceProjectDomainsNewRouteImport } from "./routes/$workspace/$project/domains/new";
import { Route as WorkspaceProjectSettingsIndexRouteImport } from "./routes/$workspace/$project/settings/index";
import { Route as WorkspaceProjectSettingsDangerRouteImport } from "./routes/$workspace/$project/settings/danger";
import { Route as WorkspaceProjectSettingsDomainsRouteImport } from "./routes/$workspace/$project/settings/domains";
import { Route as WorkspaceProjectSettingsEnvironmentsRouteImport } from "./routes/$workspace/$project/settings/environments";
import { Route as WorkspaceProjectSettingsManifestRouteImport } from "./routes/$workspace/$project/settings/manifest";
import { Route as WorkspaceProjectSettingsMembersRouteImport } from "./routes/$workspace/$project/settings/members";
import { Route as WorkspaceProjectSettingsVariablesRouteImport } from "./routes/$workspace/$project/settings/variables";
import { Route as WorkspaceProjectSettingsWebhooksRouteImport } from "./routes/$workspace/$project/settings/webhooks";

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const WorkspaceRouteRoute = WorkspaceRouteRouteImport.update({
  id: "/$workspace",
  path: "/$workspace",
  getParentRoute: () => rootRouteImport,
} as any);
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => rootRouteImport,
} as any);
const DesignRoute = DesignRouteImport.update({
  id: "/design",
  path: "/design",
  getParentRoute: () => rootRouteImport,
} as any);
const DeviceRoute = DeviceRouteImport.update({
  id: "/device",
  path: "/device",
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any);
const SignupRoute = SignupRouteImport.update({
  id: "/signup",
  path: "/signup",
  getParentRoute: () => rootRouteImport,
} as any);
const WorkspaceIndexRoute = WorkspaceIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => WorkspaceRouteRoute,
} as any);
const WorkspaceProjectRouteRoute = WorkspaceProjectRouteRouteImport.update({
  id: "/$project",
  path: "/$project",
  getParentRoute: () => WorkspaceRouteRoute,
} as any);
const WorkspaceAccountRoute = WorkspaceAccountRouteImport.update({
  id: "/account",
  path: "/account",
  getParentRoute: () => WorkspaceRouteRoute,
} as any);
const WorkspaceNewRoute = WorkspaceNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => WorkspaceRouteRoute,
} as any);
const WorkspaceSettingsRoute = WorkspaceSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => WorkspaceRouteRoute,
} as any);
const WorkspaceSpendRoute = WorkspaceSpendRouteImport.update({
  id: "/spend",
  path: "/spend",
  getParentRoute: () => WorkspaceRouteRoute,
} as any);
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AdminRouteRoute,
} as any);
const AdminAiOpsRoute = AdminAiOpsRouteImport.update({
  id: "/ai-ops",
  path: "/ai-ops",
  getParentRoute: () => AdminRouteRoute,
} as any);
const AdminIncidentsRoute = AdminIncidentsRouteImport.update({
  id: "/incidents",
  path: "/incidents",
  getParentRoute: () => AdminRouteRoute,
} as any);
const AdminMoneyRoute = AdminMoneyRouteImport.update({
  id: "/money",
  path: "/money",
  getParentRoute: () => AdminRouteRoute,
} as any);
const AdminOperationsRoute = AdminOperationsRouteImport.update({
  id: "/operations",
  path: "/operations",
  getParentRoute: () => AdminRouteRoute,
} as any);
const AdminSignupsRoute = AdminSignupsRouteImport.update({
  id: "/signups",
  path: "/signups",
  getParentRoute: () => AdminRouteRoute,
} as any);
const AdminUsageRoute = AdminUsageRouteImport.update({
  id: "/usage",
  path: "/usage",
  getParentRoute: () => AdminRouteRoute,
} as any);
const ApproveApprovalIdRoute = ApproveApprovalIdRouteImport.update({
  id: "/approve/$approvalId",
  path: "/approve/$approvalId",
  getParentRoute: () => rootRouteImport,
} as any);
const BadgeProjectRoute = BadgeProjectRouteImport.update({
  id: "/badge/$project",
  path: "/badge/$project",
  getParentRoute: () => rootRouteImport,
} as any);
const DbAccessGrantIdRoute = DbAccessGrantIdRouteImport.update({
  id: "/db-access/$grantId",
  path: "/db-access/$grantId",
  getParentRoute: () => rootRouteImport,
} as any);
const GithubCallbackRoute = GithubCallbackRouteImport.update({
  id: "/github/callback",
  path: "/github/callback",
  getParentRoute: () => rootRouteImport,
} as any);
const InvitationsAcceptRoute = InvitationsAcceptRouteImport.update({
  id: "/invitations/accept",
  path: "/invitations/accept",
  getParentRoute: () => rootRouteImport,
} as any);
const InviteCodeRoute = InviteCodeRouteImport.update({
  id: "/invite/$code",
  path: "/invite/$code",
  getParentRoute: () => rootRouteImport,
} as any);
const WaitlistConfirmRoute = WaitlistConfirmRouteImport.update({
  id: "/waitlist/confirm",
  path: "/waitlist/confirm",
  getParentRoute: () => rootRouteImport,
} as any);
const WorkspaceProjectIndexRoute = WorkspaceProjectIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => WorkspaceProjectRouteRoute,
} as any);
const WorkspaceProjectAgentsRoute = WorkspaceProjectAgentsRouteImport.update({
  id: "/agents",
  path: "/agents",
  getParentRoute: () => WorkspaceProjectRouteRoute,
} as any);
const WorkspaceProjectComplianceRoute =
  WorkspaceProjectComplianceRouteImport.update({
    id: "/compliance",
    path: "/compliance",
    getParentRoute: () => WorkspaceProjectRouteRoute,
  } as any);
const WorkspaceProjectLogsRoute = WorkspaceProjectLogsRouteImport.update({
  id: "/logs",
  path: "/logs",
  getParentRoute: () => WorkspaceProjectRouteRoute,
} as any);
const WorkspaceProjectMetricsRoute = WorkspaceProjectMetricsRouteImport.update({
  id: "/metrics",
  path: "/metrics",
  getParentRoute: () => WorkspaceProjectRouteRoute,
} as any);
const WorkspaceProjectSafetyRoute = WorkspaceProjectSafetyRouteImport.update({
  id: "/safety",
  path: "/safety",
  getParentRoute: () => WorkspaceProjectRouteRoute,
} as any);
const WorkspaceProjectSettingsRouteRoute =
  WorkspaceProjectSettingsRouteRouteImport.update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => WorkspaceProjectRouteRoute,
  } as any);
const WorkspaceProjectSpendRoute = WorkspaceProjectSpendRouteImport.update({
  id: "/spend",
  path: "/spend",
  getParentRoute: () => WorkspaceProjectRouteRoute,
} as any);
const AdminAccountsIndexRoute = AdminAccountsIndexRouteImport.update({
  id: "/accounts/",
  path: "/accounts/",
  getParentRoute: () => AdminRouteRoute,
} as any);
const AdminAccountsUserIdRoute = AdminAccountsUserIdRouteImport.update({
  id: "/accounts/$userId",
  path: "/accounts/$userId",
  getParentRoute: () => AdminRouteRoute,
} as any);
const AdminServersIndexRoute = AdminServersIndexRouteImport.update({
  id: "/servers/",
  path: "/servers/",
  getParentRoute: () => AdminRouteRoute,
} as any);
const AdminServersNodeRoute = AdminServersNodeRouteImport.update({
  id: "/servers/$node",
  path: "/servers/$node",
  getParentRoute: () => AdminRouteRoute,
} as any);
const AdminTenantsIndexRoute = AdminTenantsIndexRouteImport.update({
  id: "/tenants/",
  path: "/tenants/",
  getParentRoute: () => AdminRouteRoute,
} as any);
const AdminTenantsWorkspaceIdRoute = AdminTenantsWorkspaceIdRouteImport.update({
  id: "/tenants/$workspaceId",
  path: "/tenants/$workspaceId",
  getParentRoute: () => AdminRouteRoute,
} as any);
const WorkspaceProjectDeploymentsIndexRoute =
  WorkspaceProjectDeploymentsIndexRouteImport.update({
    id: "/deployments/",
    path: "/deployments/",
    getParentRoute: () => WorkspaceProjectRouteRoute,
  } as any);
const WorkspaceProjectDeploymentsDeploymentIdRoute =
  WorkspaceProjectDeploymentsDeploymentIdRouteImport.update({
    id: "/deployments/$deploymentId",
    path: "/deployments/$deploymentId",
    getParentRoute: () => WorkspaceProjectRouteRoute,
  } as any);
const WorkspaceProjectDomainsDomainRoute =
  WorkspaceProjectDomainsDomainRouteImport.update({
    id: "/domains/$domain",
    path: "/domains/$domain",
    getParentRoute: () => WorkspaceProjectRouteRoute,
  } as any);
const WorkspaceProjectDomainsNewRoute =
  WorkspaceProjectDomainsNewRouteImport.update({
    id: "/domains/new",
    path: "/domains/new",
    getParentRoute: () => WorkspaceProjectRouteRoute,
  } as any);
const WorkspaceProjectSettingsIndexRoute =
  WorkspaceProjectSettingsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => WorkspaceProjectSettingsRouteRoute,
  } as any);
const WorkspaceProjectSettingsDangerRoute =
  WorkspaceProjectSettingsDangerRouteImport.update({
    id: "/danger",
    path: "/danger",
    getParentRoute: () => WorkspaceProjectSettingsRouteRoute,
  } as any);
const WorkspaceProjectSettingsDomainsRoute =
  WorkspaceProjectSettingsDomainsRouteImport.update({
    id: "/domains",
    path: "/domains",
    getParentRoute: () => WorkspaceProjectSettingsRouteRoute,
  } as any);
const WorkspaceProjectSettingsEnvironmentsRoute =
  WorkspaceProjectSettingsEnvironmentsRouteImport.update({
    id: "/environments",
    path: "/environments",
    getParentRoute: () => WorkspaceProjectSettingsRouteRoute,
  } as any);
const WorkspaceProjectSettingsManifestRoute =
  WorkspaceProjectSettingsManifestRouteImport.update({
    id: "/manifest",
    path: "/manifest",
    getParentRoute: () => WorkspaceProjectSettingsRouteRoute,
  } as any);
const WorkspaceProjectSettingsMembersRoute =
  WorkspaceProjectSettingsMembersRouteImport.update({
    id: "/members",
    path: "/members",
    getParentRoute: () => WorkspaceProjectSettingsRouteRoute,
  } as any);
const WorkspaceProjectSettingsVariablesRoute =
  WorkspaceProjectSettingsVariablesRouteImport.update({
    id: "/variables",
    path: "/variables",
    getParentRoute: () => WorkspaceProjectSettingsRouteRoute,
  } as any);
const WorkspaceProjectSettingsWebhooksRoute =
  WorkspaceProjectSettingsWebhooksRouteImport.update({
    id: "/webhooks",
    path: "/webhooks",
    getParentRoute: () => WorkspaceProjectSettingsRouteRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/$workspace": typeof WorkspaceRouteRouteWithChildren;
  "/admin": typeof AdminRouteRouteWithChildren;
  "/design": typeof DesignRoute;
  "/device": typeof DeviceRoute;
  "/login": typeof LoginRoute;
  "/signup": typeof SignupRoute;
  "/$workspace/$project": typeof WorkspaceProjectRouteRouteWithChildren;
  "/$workspace/account": typeof WorkspaceAccountRoute;
  "/$workspace/new": typeof WorkspaceNewRoute;
  "/$workspace/settings": typeof WorkspaceSettingsRoute;
  "/$workspace/spend": typeof WorkspaceSpendRoute;
  "/admin/ai-ops": typeof AdminAiOpsRoute;
  "/admin/incidents": typeof AdminIncidentsRoute;
  "/admin/money": typeof AdminMoneyRoute;
  "/admin/operations": typeof AdminOperationsRoute;
  "/admin/signups": typeof AdminSignupsRoute;
  "/admin/usage": typeof AdminUsageRoute;
  "/approve/$approvalId": typeof ApproveApprovalIdRoute;
  "/badge/$project": typeof BadgeProjectRoute;
  "/db-access/$grantId": typeof DbAccessGrantIdRoute;
  "/github/callback": typeof GithubCallbackRoute;
  "/invitations/accept": typeof InvitationsAcceptRoute;
  "/invite/$code": typeof InviteCodeRoute;
  "/waitlist/confirm": typeof WaitlistConfirmRoute;
  "/$workspace/": typeof WorkspaceIndexRoute;
  "/admin/": typeof AdminIndexRoute;
  "/$workspace/$project/settings": typeof WorkspaceProjectSettingsRouteRouteWithChildren;
  "/$workspace/$project/agents": typeof WorkspaceProjectAgentsRoute;
  "/$workspace/$project/compliance": typeof WorkspaceProjectComplianceRoute;
  "/$workspace/$project/logs": typeof WorkspaceProjectLogsRoute;
  "/$workspace/$project/metrics": typeof WorkspaceProjectMetricsRoute;
  "/$workspace/$project/safety": typeof WorkspaceProjectSafetyRoute;
  "/$workspace/$project/spend": typeof WorkspaceProjectSpendRoute;
  "/admin/accounts/$userId": typeof AdminAccountsUserIdRoute;
  "/admin/servers/$node": typeof AdminServersNodeRoute;
  "/admin/tenants/$workspaceId": typeof AdminTenantsWorkspaceIdRoute;
  "/$workspace/$project/": typeof WorkspaceProjectIndexRoute;
  "/admin/accounts/": typeof AdminAccountsIndexRoute;
  "/admin/servers/": typeof AdminServersIndexRoute;
  "/admin/tenants/": typeof AdminTenantsIndexRoute;
  "/$workspace/$project/deployments/$deploymentId": typeof WorkspaceProjectDeploymentsDeploymentIdRoute;
  "/$workspace/$project/domains/$domain": typeof WorkspaceProjectDomainsDomainRoute;
  "/$workspace/$project/domains/new": typeof WorkspaceProjectDomainsNewRoute;
  "/$workspace/$project/settings/danger": typeof WorkspaceProjectSettingsDangerRoute;
  "/$workspace/$project/settings/domains": typeof WorkspaceProjectSettingsDomainsRoute;
  "/$workspace/$project/settings/environments": typeof WorkspaceProjectSettingsEnvironmentsRoute;
  "/$workspace/$project/settings/manifest": typeof WorkspaceProjectSettingsManifestRoute;
  "/$workspace/$project/settings/members": typeof WorkspaceProjectSettingsMembersRoute;
  "/$workspace/$project/settings/variables": typeof WorkspaceProjectSettingsVariablesRoute;
  "/$workspace/$project/settings/webhooks": typeof WorkspaceProjectSettingsWebhooksRoute;
  "/$workspace/$project/deployments/": typeof WorkspaceProjectDeploymentsIndexRoute;
  "/$workspace/$project/settings/": typeof WorkspaceProjectSettingsIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/design": typeof DesignRoute;
  "/device": typeof DeviceRoute;
  "/login": typeof LoginRoute;
  "/signup": typeof SignupRoute;
  "/$workspace/account": typeof WorkspaceAccountRoute;
  "/$workspace/new": typeof WorkspaceNewRoute;
  "/$workspace/settings": typeof WorkspaceSettingsRoute;
  "/$workspace/spend": typeof WorkspaceSpendRoute;
  "/admin/ai-ops": typeof AdminAiOpsRoute;
  "/admin/incidents": typeof AdminIncidentsRoute;
  "/admin/money": typeof AdminMoneyRoute;
  "/admin/operations": typeof AdminOperationsRoute;
  "/admin/signups": typeof AdminSignupsRoute;
  "/admin/usage": typeof AdminUsageRoute;
  "/approve/$approvalId": typeof ApproveApprovalIdRoute;
  "/badge/$project": typeof BadgeProjectRoute;
  "/db-access/$grantId": typeof DbAccessGrantIdRoute;
  "/github/callback": typeof GithubCallbackRoute;
  "/invitations/accept": typeof InvitationsAcceptRoute;
  "/invite/$code": typeof InviteCodeRoute;
  "/waitlist/confirm": typeof WaitlistConfirmRoute;
  "/$workspace": typeof WorkspaceIndexRoute;
  "/admin": typeof AdminIndexRoute;
  "/$workspace/$project/agents": typeof WorkspaceProjectAgentsRoute;
  "/$workspace/$project/compliance": typeof WorkspaceProjectComplianceRoute;
  "/$workspace/$project/logs": typeof WorkspaceProjectLogsRoute;
  "/$workspace/$project/metrics": typeof WorkspaceProjectMetricsRoute;
  "/$workspace/$project/safety": typeof WorkspaceProjectSafetyRoute;
  "/$workspace/$project/spend": typeof WorkspaceProjectSpendRoute;
  "/admin/accounts/$userId": typeof AdminAccountsUserIdRoute;
  "/admin/servers/$node": typeof AdminServersNodeRoute;
  "/admin/tenants/$workspaceId": typeof AdminTenantsWorkspaceIdRoute;
  "/$workspace/$project": typeof WorkspaceProjectIndexRoute;
  "/admin/accounts": typeof AdminAccountsIndexRoute;
  "/admin/servers": typeof AdminServersIndexRoute;
  "/admin/tenants": typeof AdminTenantsIndexRoute;
  "/$workspace/$project/deployments/$deploymentId": typeof WorkspaceProjectDeploymentsDeploymentIdRoute;
  "/$workspace/$project/domains/$domain": typeof WorkspaceProjectDomainsDomainRoute;
  "/$workspace/$project/domains/new": typeof WorkspaceProjectDomainsNewRoute;
  "/$workspace/$project/settings/danger": typeof WorkspaceProjectSettingsDangerRoute;
  "/$workspace/$project/settings/domains": typeof WorkspaceProjectSettingsDomainsRoute;
  "/$workspace/$project/settings/environments": typeof WorkspaceProjectSettingsEnvironmentsRoute;
  "/$workspace/$project/settings/manifest": typeof WorkspaceProjectSettingsManifestRoute;
  "/$workspace/$project/settings/members": typeof WorkspaceProjectSettingsMembersRoute;
  "/$workspace/$project/settings/variables": typeof WorkspaceProjectSettingsVariablesRoute;
  "/$workspace/$project/settings/webhooks": typeof WorkspaceProjectSettingsWebhooksRoute;
  "/$workspace/$project/deployments": typeof WorkspaceProjectDeploymentsIndexRoute;
  "/$workspace/$project/settings": typeof WorkspaceProjectSettingsIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/$workspace": typeof WorkspaceRouteRouteWithChildren;
  "/admin": typeof AdminRouteRouteWithChildren;
  "/design": typeof DesignRoute;
  "/device": typeof DeviceRoute;
  "/login": typeof LoginRoute;
  "/signup": typeof SignupRoute;
  "/$workspace/$project": typeof WorkspaceProjectRouteRouteWithChildren;
  "/$workspace/account": typeof WorkspaceAccountRoute;
  "/$workspace/new": typeof WorkspaceNewRoute;
  "/$workspace/settings": typeof WorkspaceSettingsRoute;
  "/$workspace/spend": typeof WorkspaceSpendRoute;
  "/admin/ai-ops": typeof AdminAiOpsRoute;
  "/admin/incidents": typeof AdminIncidentsRoute;
  "/admin/money": typeof AdminMoneyRoute;
  "/admin/operations": typeof AdminOperationsRoute;
  "/admin/signups": typeof AdminSignupsRoute;
  "/admin/usage": typeof AdminUsageRoute;
  "/approve/$approvalId": typeof ApproveApprovalIdRoute;
  "/badge/$project": typeof BadgeProjectRoute;
  "/db-access/$grantId": typeof DbAccessGrantIdRoute;
  "/github/callback": typeof GithubCallbackRoute;
  "/invitations/accept": typeof InvitationsAcceptRoute;
  "/invite/$code": typeof InviteCodeRoute;
  "/waitlist/confirm": typeof WaitlistConfirmRoute;
  "/$workspace/": typeof WorkspaceIndexRoute;
  "/admin/": typeof AdminIndexRoute;
  "/$workspace/$project/settings": typeof WorkspaceProjectSettingsRouteRouteWithChildren;
  "/$workspace/$project/agents": typeof WorkspaceProjectAgentsRoute;
  "/$workspace/$project/compliance": typeof WorkspaceProjectComplianceRoute;
  "/$workspace/$project/logs": typeof WorkspaceProjectLogsRoute;
  "/$workspace/$project/metrics": typeof WorkspaceProjectMetricsRoute;
  "/$workspace/$project/safety": typeof WorkspaceProjectSafetyRoute;
  "/$workspace/$project/spend": typeof WorkspaceProjectSpendRoute;
  "/admin/accounts/$userId": typeof AdminAccountsUserIdRoute;
  "/admin/servers/$node": typeof AdminServersNodeRoute;
  "/admin/tenants/$workspaceId": typeof AdminTenantsWorkspaceIdRoute;
  "/$workspace/$project/": typeof WorkspaceProjectIndexRoute;
  "/admin/accounts/": typeof AdminAccountsIndexRoute;
  "/admin/servers/": typeof AdminServersIndexRoute;
  "/admin/tenants/": typeof AdminTenantsIndexRoute;
  "/$workspace/$project/deployments/$deploymentId": typeof WorkspaceProjectDeploymentsDeploymentIdRoute;
  "/$workspace/$project/domains/$domain": typeof WorkspaceProjectDomainsDomainRoute;
  "/$workspace/$project/domains/new": typeof WorkspaceProjectDomainsNewRoute;
  "/$workspace/$project/settings/danger": typeof WorkspaceProjectSettingsDangerRoute;
  "/$workspace/$project/settings/domains": typeof WorkspaceProjectSettingsDomainsRoute;
  "/$workspace/$project/settings/environments": typeof WorkspaceProjectSettingsEnvironmentsRoute;
  "/$workspace/$project/settings/manifest": typeof WorkspaceProjectSettingsManifestRoute;
  "/$workspace/$project/settings/members": typeof WorkspaceProjectSettingsMembersRoute;
  "/$workspace/$project/settings/variables": typeof WorkspaceProjectSettingsVariablesRoute;
  "/$workspace/$project/settings/webhooks": typeof WorkspaceProjectSettingsWebhooksRoute;
  "/$workspace/$project/deployments/": typeof WorkspaceProjectDeploymentsIndexRoute;
  "/$workspace/$project/settings/": typeof WorkspaceProjectSettingsIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/$workspace"
    | "/admin"
    | "/design"
    | "/device"
    | "/login"
    | "/signup"
    | "/$workspace/$project"
    | "/$workspace/account"
    | "/$workspace/new"
    | "/$workspace/settings"
    | "/$workspace/spend"
    | "/admin/ai-ops"
    | "/admin/incidents"
    | "/admin/money"
    | "/admin/operations"
    | "/admin/signups"
    | "/admin/usage"
    | "/approve/$approvalId"
    | "/badge/$project"
    | "/db-access/$grantId"
    | "/github/callback"
    | "/invitations/accept"
    | "/invite/$code"
    | "/waitlist/confirm"
    | "/$workspace/"
    | "/admin/"
    | "/$workspace/$project/settings"
    | "/$workspace/$project/agents"
    | "/$workspace/$project/compliance"
    | "/$workspace/$project/logs"
    | "/$workspace/$project/metrics"
    | "/$workspace/$project/safety"
    | "/$workspace/$project/spend"
    | "/admin/accounts/$userId"
    | "/admin/servers/$node"
    | "/admin/tenants/$workspaceId"
    | "/$workspace/$project/"
    | "/admin/accounts/"
    | "/admin/servers/"
    | "/admin/tenants/"
    | "/$workspace/$project/deployments/$deploymentId"
    | "/$workspace/$project/domains/$domain"
    | "/$workspace/$project/domains/new"
    | "/$workspace/$project/settings/danger"
    | "/$workspace/$project/settings/domains"
    | "/$workspace/$project/settings/environments"
    | "/$workspace/$project/settings/manifest"
    | "/$workspace/$project/settings/members"
    | "/$workspace/$project/settings/variables"
    | "/$workspace/$project/settings/webhooks"
    | "/$workspace/$project/deployments/"
    | "/$workspace/$project/settings/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/design"
    | "/device"
    | "/login"
    | "/signup"
    | "/$workspace/account"
    | "/$workspace/new"
    | "/$workspace/settings"
    | "/$workspace/spend"
    | "/admin/ai-ops"
    | "/admin/incidents"
    | "/admin/money"
    | "/admin/operations"
    | "/admin/signups"
    | "/admin/usage"
    | "/approve/$approvalId"
    | "/badge/$project"
    | "/db-access/$grantId"
    | "/github/callback"
    | "/invitations/accept"
    | "/invite/$code"
    | "/waitlist/confirm"
    | "/$workspace"
    | "/admin"
    | "/$workspace/$project/agents"
    | "/$workspace/$project/compliance"
    | "/$workspace/$project/logs"
    | "/$workspace/$project/metrics"
    | "/$workspace/$project/safety"
    | "/$workspace/$project/spend"
    | "/admin/accounts/$userId"
    | "/admin/servers/$node"
    | "/admin/tenants/$workspaceId"
    | "/$workspace/$project"
    | "/admin/accounts"
    | "/admin/servers"
    | "/admin/tenants"
    | "/$workspace/$project/deployments/$deploymentId"
    | "/$workspace/$project/domains/$domain"
    | "/$workspace/$project/domains/new"
    | "/$workspace/$project/settings/danger"
    | "/$workspace/$project/settings/domains"
    | "/$workspace/$project/settings/environments"
    | "/$workspace/$project/settings/manifest"
    | "/$workspace/$project/settings/members"
    | "/$workspace/$project/settings/variables"
    | "/$workspace/$project/settings/webhooks"
    | "/$workspace/$project/deployments"
    | "/$workspace/$project/settings";
  id:
    | "__root__"
    | "/"
    | "/$workspace"
    | "/admin"
    | "/design"
    | "/device"
    | "/login"
    | "/signup"
    | "/$workspace/$project"
    | "/$workspace/account"
    | "/$workspace/new"
    | "/$workspace/settings"
    | "/$workspace/spend"
    | "/admin/ai-ops"
    | "/admin/incidents"
    | "/admin/money"
    | "/admin/operations"
    | "/admin/signups"
    | "/admin/usage"
    | "/approve/$approvalId"
    | "/badge/$project"
    | "/db-access/$grantId"
    | "/github/callback"
    | "/invitations/accept"
    | "/invite/$code"
    | "/waitlist/confirm"
    | "/$workspace/"
    | "/admin/"
    | "/$workspace/$project/settings"
    | "/$workspace/$project/agents"
    | "/$workspace/$project/compliance"
    | "/$workspace/$project/logs"
    | "/$workspace/$project/metrics"
    | "/$workspace/$project/safety"
    | "/$workspace/$project/spend"
    | "/admin/accounts/$userId"
    | "/admin/servers/$node"
    | "/admin/tenants/$workspaceId"
    | "/$workspace/$project/"
    | "/admin/accounts/"
    | "/admin/servers/"
    | "/admin/tenants/"
    | "/$workspace/$project/deployments/$deploymentId"
    | "/$workspace/$project/domains/$domain"
    | "/$workspace/$project/domains/new"
    | "/$workspace/$project/settings/danger"
    | "/$workspace/$project/settings/domains"
    | "/$workspace/$project/settings/environments"
    | "/$workspace/$project/settings/manifest"
    | "/$workspace/$project/settings/members"
    | "/$workspace/$project/settings/variables"
    | "/$workspace/$project/settings/webhooks"
    | "/$workspace/$project/deployments/"
    | "/$workspace/$project/settings/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  WorkspaceRouteRoute: typeof WorkspaceRouteRouteWithChildren;
  AdminRouteRoute: typeof AdminRouteRouteWithChildren;
  DesignRoute: typeof DesignRoute;
  DeviceRoute: typeof DeviceRoute;
  LoginRoute: typeof LoginRoute;
  SignupRoute: typeof SignupRoute;
  ApproveApprovalIdRoute: typeof ApproveApprovalIdRoute;
  BadgeProjectRoute: typeof BadgeProjectRoute;
  DbAccessGrantIdRoute: typeof DbAccessGrantIdRoute;
  GithubCallbackRoute: typeof GithubCallbackRoute;
  InvitationsAcceptRoute: typeof InvitationsAcceptRoute;
  InviteCodeRoute: typeof InviteCodeRoute;
  WaitlistConfirmRoute: typeof WaitlistConfirmRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/$workspace": {
      id: "/$workspace";
      path: "/$workspace";
      fullPath: "/$workspace";
      preLoaderRoute: typeof WorkspaceRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/admin": {
      id: "/admin";
      path: "/admin";
      fullPath: "/admin";
      preLoaderRoute: typeof AdminRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/design": {
      id: "/design";
      path: "/design";
      fullPath: "/design";
      preLoaderRoute: typeof DesignRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/device": {
      id: "/device";
      path: "/device";
      fullPath: "/device";
      preLoaderRoute: typeof DeviceRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/login": {
      id: "/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/signup": {
      id: "/signup";
      path: "/signup";
      fullPath: "/signup";
      preLoaderRoute: typeof SignupRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/$workspace/": {
      id: "/$workspace/";
      path: "/";
      fullPath: "/$workspace/";
      preLoaderRoute: typeof WorkspaceIndexRouteImport;
      parentRoute: typeof WorkspaceRouteRoute;
    };
    "/$workspace/$project": {
      id: "/$workspace/$project";
      path: "/$project";
      fullPath: "/$workspace/$project";
      preLoaderRoute: typeof WorkspaceProjectRouteRouteImport;
      parentRoute: typeof WorkspaceRouteRoute;
    };
    "/$workspace/account": {
      id: "/$workspace/account";
      path: "/account";
      fullPath: "/$workspace/account";
      preLoaderRoute: typeof WorkspaceAccountRouteImport;
      parentRoute: typeof WorkspaceRouteRoute;
    };
    "/$workspace/new": {
      id: "/$workspace/new";
      path: "/new";
      fullPath: "/$workspace/new";
      preLoaderRoute: typeof WorkspaceNewRouteImport;
      parentRoute: typeof WorkspaceRouteRoute;
    };
    "/$workspace/settings": {
      id: "/$workspace/settings";
      path: "/settings";
      fullPath: "/$workspace/settings";
      preLoaderRoute: typeof WorkspaceSettingsRouteImport;
      parentRoute: typeof WorkspaceRouteRoute;
    };
    "/$workspace/spend": {
      id: "/$workspace/spend";
      path: "/spend";
      fullPath: "/$workspace/spend";
      preLoaderRoute: typeof WorkspaceSpendRouteImport;
      parentRoute: typeof WorkspaceRouteRoute;
    };
    "/admin/": {
      id: "/admin/";
      path: "/";
      fullPath: "/admin/";
      preLoaderRoute: typeof AdminIndexRouteImport;
      parentRoute: typeof AdminRouteRoute;
    };
    "/admin/ai-ops": {
      id: "/admin/ai-ops";
      path: "/ai-ops";
      fullPath: "/admin/ai-ops";
      preLoaderRoute: typeof AdminAiOpsRouteImport;
      parentRoute: typeof AdminRouteRoute;
    };
    "/admin/incidents": {
      id: "/admin/incidents";
      path: "/incidents";
      fullPath: "/admin/incidents";
      preLoaderRoute: typeof AdminIncidentsRouteImport;
      parentRoute: typeof AdminRouteRoute;
    };
    "/admin/money": {
      id: "/admin/money";
      path: "/money";
      fullPath: "/admin/money";
      preLoaderRoute: typeof AdminMoneyRouteImport;
      parentRoute: typeof AdminRouteRoute;
    };
    "/admin/operations": {
      id: "/admin/operations";
      path: "/operations";
      fullPath: "/admin/operations";
      preLoaderRoute: typeof AdminOperationsRouteImport;
      parentRoute: typeof AdminRouteRoute;
    };
    "/admin/signups": {
      id: "/admin/signups";
      path: "/signups";
      fullPath: "/admin/signups";
      preLoaderRoute: typeof AdminSignupsRouteImport;
      parentRoute: typeof AdminRouteRoute;
    };
    "/admin/usage": {
      id: "/admin/usage";
      path: "/usage";
      fullPath: "/admin/usage";
      preLoaderRoute: typeof AdminUsageRouteImport;
      parentRoute: typeof AdminRouteRoute;
    };
    "/approve/$approvalId": {
      id: "/approve/$approvalId";
      path: "/approve/$approvalId";
      fullPath: "/approve/$approvalId";
      preLoaderRoute: typeof ApproveApprovalIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/badge/$project": {
      id: "/badge/$project";
      path: "/badge/$project";
      fullPath: "/badge/$project";
      preLoaderRoute: typeof BadgeProjectRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/db-access/$grantId": {
      id: "/db-access/$grantId";
      path: "/db-access/$grantId";
      fullPath: "/db-access/$grantId";
      preLoaderRoute: typeof DbAccessGrantIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/github/callback": {
      id: "/github/callback";
      path: "/github/callback";
      fullPath: "/github/callback";
      preLoaderRoute: typeof GithubCallbackRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/invitations/accept": {
      id: "/invitations/accept";
      path: "/invitations/accept";
      fullPath: "/invitations/accept";
      preLoaderRoute: typeof InvitationsAcceptRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/invite/$code": {
      id: "/invite/$code";
      path: "/invite/$code";
      fullPath: "/invite/$code";
      preLoaderRoute: typeof InviteCodeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/waitlist/confirm": {
      id: "/waitlist/confirm";
      path: "/waitlist/confirm";
      fullPath: "/waitlist/confirm";
      preLoaderRoute: typeof WaitlistConfirmRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/$workspace/$project/": {
      id: "/$workspace/$project/";
      path: "/";
      fullPath: "/$workspace/$project/";
      preLoaderRoute: typeof WorkspaceProjectIndexRouteImport;
      parentRoute: typeof WorkspaceProjectRouteRoute;
    };
    "/$workspace/$project/agents": {
      id: "/$workspace/$project/agents";
      path: "/agents";
      fullPath: "/$workspace/$project/agents";
      preLoaderRoute: typeof WorkspaceProjectAgentsRouteImport;
      parentRoute: typeof WorkspaceProjectRouteRoute;
    };
    "/$workspace/$project/compliance": {
      id: "/$workspace/$project/compliance";
      path: "/compliance";
      fullPath: "/$workspace/$project/compliance";
      preLoaderRoute: typeof WorkspaceProjectComplianceRouteImport;
      parentRoute: typeof WorkspaceProjectRouteRoute;
    };
    "/$workspace/$project/logs": {
      id: "/$workspace/$project/logs";
      path: "/logs";
      fullPath: "/$workspace/$project/logs";
      preLoaderRoute: typeof WorkspaceProjectLogsRouteImport;
      parentRoute: typeof WorkspaceProjectRouteRoute;
    };
    "/$workspace/$project/metrics": {
      id: "/$workspace/$project/metrics";
      path: "/metrics";
      fullPath: "/$workspace/$project/metrics";
      preLoaderRoute: typeof WorkspaceProjectMetricsRouteImport;
      parentRoute: typeof WorkspaceProjectRouteRoute;
    };
    "/$workspace/$project/safety": {
      id: "/$workspace/$project/safety";
      path: "/safety";
      fullPath: "/$workspace/$project/safety";
      preLoaderRoute: typeof WorkspaceProjectSafetyRouteImport;
      parentRoute: typeof WorkspaceProjectRouteRoute;
    };
    "/$workspace/$project/settings": {
      id: "/$workspace/$project/settings";
      path: "/settings";
      fullPath: "/$workspace/$project/settings";
      preLoaderRoute: typeof WorkspaceProjectSettingsRouteRouteImport;
      parentRoute: typeof WorkspaceProjectRouteRoute;
    };
    "/$workspace/$project/spend": {
      id: "/$workspace/$project/spend";
      path: "/spend";
      fullPath: "/$workspace/$project/spend";
      preLoaderRoute: typeof WorkspaceProjectSpendRouteImport;
      parentRoute: typeof WorkspaceProjectRouteRoute;
    };
    "/admin/accounts/": {
      id: "/admin/accounts/";
      path: "/accounts";
      fullPath: "/admin/accounts/";
      preLoaderRoute: typeof AdminAccountsIndexRouteImport;
      parentRoute: typeof AdminRouteRoute;
    };
    "/admin/accounts/$userId": {
      id: "/admin/accounts/$userId";
      path: "/accounts/$userId";
      fullPath: "/admin/accounts/$userId";
      preLoaderRoute: typeof AdminAccountsUserIdRouteImport;
      parentRoute: typeof AdminRouteRoute;
    };
    "/admin/servers/": {
      id: "/admin/servers/";
      path: "/servers";
      fullPath: "/admin/servers/";
      preLoaderRoute: typeof AdminServersIndexRouteImport;
      parentRoute: typeof AdminRouteRoute;
    };
    "/admin/servers/$node": {
      id: "/admin/servers/$node";
      path: "/servers/$node";
      fullPath: "/admin/servers/$node";
      preLoaderRoute: typeof AdminServersNodeRouteImport;
      parentRoute: typeof AdminRouteRoute;
    };
    "/admin/tenants/": {
      id: "/admin/tenants/";
      path: "/tenants";
      fullPath: "/admin/tenants/";
      preLoaderRoute: typeof AdminTenantsIndexRouteImport;
      parentRoute: typeof AdminRouteRoute;
    };
    "/admin/tenants/$workspaceId": {
      id: "/admin/tenants/$workspaceId";
      path: "/tenants/$workspaceId";
      fullPath: "/admin/tenants/$workspaceId";
      preLoaderRoute: typeof AdminTenantsWorkspaceIdRouteImport;
      parentRoute: typeof AdminRouteRoute;
    };
    "/$workspace/$project/deployments/": {
      id: "/$workspace/$project/deployments/";
      path: "/deployments";
      fullPath: "/$workspace/$project/deployments/";
      preLoaderRoute: typeof WorkspaceProjectDeploymentsIndexRouteImport;
      parentRoute: typeof WorkspaceProjectRouteRoute;
    };
    "/$workspace/$project/deployments/$deploymentId": {
      id: "/$workspace/$project/deployments/$deploymentId";
      path: "/deployments/$deploymentId";
      fullPath: "/$workspace/$project/deployments/$deploymentId";
      preLoaderRoute: typeof WorkspaceProjectDeploymentsDeploymentIdRouteImport;
      parentRoute: typeof WorkspaceProjectRouteRoute;
    };
    "/$workspace/$project/domains/$domain": {
      id: "/$workspace/$project/domains/$domain";
      path: "/domains/$domain";
      fullPath: "/$workspace/$project/domains/$domain";
      preLoaderRoute: typeof WorkspaceProjectDomainsDomainRouteImport;
      parentRoute: typeof WorkspaceProjectRouteRoute;
    };
    "/$workspace/$project/domains/new": {
      id: "/$workspace/$project/domains/new";
      path: "/domains/new";
      fullPath: "/$workspace/$project/domains/new";
      preLoaderRoute: typeof WorkspaceProjectDomainsNewRouteImport;
      parentRoute: typeof WorkspaceProjectRouteRoute;
    };
    "/$workspace/$project/settings/": {
      id: "/$workspace/$project/settings/";
      path: "/";
      fullPath: "/$workspace/$project/settings/";
      preLoaderRoute: typeof WorkspaceProjectSettingsIndexRouteImport;
      parentRoute: typeof WorkspaceProjectSettingsRouteRoute;
    };
    "/$workspace/$project/settings/danger": {
      id: "/$workspace/$project/settings/danger";
      path: "/danger";
      fullPath: "/$workspace/$project/settings/danger";
      preLoaderRoute: typeof WorkspaceProjectSettingsDangerRouteImport;
      parentRoute: typeof WorkspaceProjectSettingsRouteRoute;
    };
    "/$workspace/$project/settings/domains": {
      id: "/$workspace/$project/settings/domains";
      path: "/domains";
      fullPath: "/$workspace/$project/settings/domains";
      preLoaderRoute: typeof WorkspaceProjectSettingsDomainsRouteImport;
      parentRoute: typeof WorkspaceProjectSettingsRouteRoute;
    };
    "/$workspace/$project/settings/environments": {
      id: "/$workspace/$project/settings/environments";
      path: "/environments";
      fullPath: "/$workspace/$project/settings/environments";
      preLoaderRoute: typeof WorkspaceProjectSettingsEnvironmentsRouteImport;
      parentRoute: typeof WorkspaceProjectSettingsRouteRoute;
    };
    "/$workspace/$project/settings/manifest": {
      id: "/$workspace/$project/settings/manifest";
      path: "/manifest";
      fullPath: "/$workspace/$project/settings/manifest";
      preLoaderRoute: typeof WorkspaceProjectSettingsManifestRouteImport;
      parentRoute: typeof WorkspaceProjectSettingsRouteRoute;
    };
    "/$workspace/$project/settings/members": {
      id: "/$workspace/$project/settings/members";
      path: "/members";
      fullPath: "/$workspace/$project/settings/members";
      preLoaderRoute: typeof WorkspaceProjectSettingsMembersRouteImport;
      parentRoute: typeof WorkspaceProjectSettingsRouteRoute;
    };
    "/$workspace/$project/settings/variables": {
      id: "/$workspace/$project/settings/variables";
      path: "/variables";
      fullPath: "/$workspace/$project/settings/variables";
      preLoaderRoute: typeof WorkspaceProjectSettingsVariablesRouteImport;
      parentRoute: typeof WorkspaceProjectSettingsRouteRoute;
    };
    "/$workspace/$project/settings/webhooks": {
      id: "/$workspace/$project/settings/webhooks";
      path: "/webhooks";
      fullPath: "/$workspace/$project/settings/webhooks";
      preLoaderRoute: typeof WorkspaceProjectSettingsWebhooksRouteImport;
      parentRoute: typeof WorkspaceProjectSettingsRouteRoute;
    };
  }
}

interface WorkspaceProjectSettingsRouteRouteChildren {
  WorkspaceProjectSettingsDangerRoute: typeof WorkspaceProjectSettingsDangerRoute;
  WorkspaceProjectSettingsDomainsRoute: typeof WorkspaceProjectSettingsDomainsRoute;
  WorkspaceProjectSettingsEnvironmentsRoute: typeof WorkspaceProjectSettingsEnvironmentsRoute;
  WorkspaceProjectSettingsManifestRoute: typeof WorkspaceProjectSettingsManifestRoute;
  WorkspaceProjectSettingsMembersRoute: typeof WorkspaceProjectSettingsMembersRoute;
  WorkspaceProjectSettingsVariablesRoute: typeof WorkspaceProjectSettingsVariablesRoute;
  WorkspaceProjectSettingsWebhooksRoute: typeof WorkspaceProjectSettingsWebhooksRoute;
  WorkspaceProjectSettingsIndexRoute: typeof WorkspaceProjectSettingsIndexRoute;
}

const WorkspaceProjectSettingsRouteRouteChildren: WorkspaceProjectSettingsRouteRouteChildren =
  {
    WorkspaceProjectSettingsDangerRoute: WorkspaceProjectSettingsDangerRoute,
    WorkspaceProjectSettingsDomainsRoute: WorkspaceProjectSettingsDomainsRoute,
    WorkspaceProjectSettingsEnvironmentsRoute:
      WorkspaceProjectSettingsEnvironmentsRoute,
    WorkspaceProjectSettingsManifestRoute:
      WorkspaceProjectSettingsManifestRoute,
    WorkspaceProjectSettingsMembersRoute: WorkspaceProjectSettingsMembersRoute,
    WorkspaceProjectSettingsVariablesRoute:
      WorkspaceProjectSettingsVariablesRoute,
    WorkspaceProjectSettingsWebhooksRoute:
      WorkspaceProjectSettingsWebhooksRoute,
    WorkspaceProjectSettingsIndexRoute: WorkspaceProjectSettingsIndexRoute,
  };

const WorkspaceProjectSettingsRouteRouteWithChildren =
  WorkspaceProjectSettingsRouteRoute._addFileChildren(
    WorkspaceProjectSettingsRouteRouteChildren,
  );

interface WorkspaceProjectRouteRouteChildren {
  WorkspaceProjectSettingsRouteRoute: typeof WorkspaceProjectSettingsRouteRouteWithChildren;
  WorkspaceProjectAgentsRoute: typeof WorkspaceProjectAgentsRoute;
  WorkspaceProjectComplianceRoute: typeof WorkspaceProjectComplianceRoute;
  WorkspaceProjectLogsRoute: typeof WorkspaceProjectLogsRoute;
  WorkspaceProjectMetricsRoute: typeof WorkspaceProjectMetricsRoute;
  WorkspaceProjectSafetyRoute: typeof WorkspaceProjectSafetyRoute;
  WorkspaceProjectSpendRoute: typeof WorkspaceProjectSpendRoute;
  WorkspaceProjectIndexRoute: typeof WorkspaceProjectIndexRoute;
  WorkspaceProjectDeploymentsDeploymentIdRoute: typeof WorkspaceProjectDeploymentsDeploymentIdRoute;
  WorkspaceProjectDomainsDomainRoute: typeof WorkspaceProjectDomainsDomainRoute;
  WorkspaceProjectDomainsNewRoute: typeof WorkspaceProjectDomainsNewRoute;
  WorkspaceProjectDeploymentsIndexRoute: typeof WorkspaceProjectDeploymentsIndexRoute;
}

const WorkspaceProjectRouteRouteChildren: WorkspaceProjectRouteRouteChildren = {
  WorkspaceProjectSettingsRouteRoute:
    WorkspaceProjectSettingsRouteRouteWithChildren,
  WorkspaceProjectAgentsRoute: WorkspaceProjectAgentsRoute,
  WorkspaceProjectComplianceRoute: WorkspaceProjectComplianceRoute,
  WorkspaceProjectLogsRoute: WorkspaceProjectLogsRoute,
  WorkspaceProjectMetricsRoute: WorkspaceProjectMetricsRoute,
  WorkspaceProjectSafetyRoute: WorkspaceProjectSafetyRoute,
  WorkspaceProjectSpendRoute: WorkspaceProjectSpendRoute,
  WorkspaceProjectIndexRoute: WorkspaceProjectIndexRoute,
  WorkspaceProjectDeploymentsDeploymentIdRoute:
    WorkspaceProjectDeploymentsDeploymentIdRoute,
  WorkspaceProjectDomainsDomainRoute: WorkspaceProjectDomainsDomainRoute,
  WorkspaceProjectDomainsNewRoute: WorkspaceProjectDomainsNewRoute,
  WorkspaceProjectDeploymentsIndexRoute: WorkspaceProjectDeploymentsIndexRoute,
};

const WorkspaceProjectRouteRouteWithChildren =
  WorkspaceProjectRouteRoute._addFileChildren(
    WorkspaceProjectRouteRouteChildren,
  );

interface WorkspaceRouteRouteChildren {
  WorkspaceProjectRouteRoute: typeof WorkspaceProjectRouteRouteWithChildren;
  WorkspaceAccountRoute: typeof WorkspaceAccountRoute;
  WorkspaceNewRoute: typeof WorkspaceNewRoute;
  WorkspaceSettingsRoute: typeof WorkspaceSettingsRoute;
  WorkspaceSpendRoute: typeof WorkspaceSpendRoute;
  WorkspaceIndexRoute: typeof WorkspaceIndexRoute;
}

const WorkspaceRouteRouteChildren: WorkspaceRouteRouteChildren = {
  WorkspaceProjectRouteRoute: WorkspaceProjectRouteRouteWithChildren,
  WorkspaceAccountRoute: WorkspaceAccountRoute,
  WorkspaceNewRoute: WorkspaceNewRoute,
  WorkspaceSettingsRoute: WorkspaceSettingsRoute,
  WorkspaceSpendRoute: WorkspaceSpendRoute,
  WorkspaceIndexRoute: WorkspaceIndexRoute,
};

const WorkspaceRouteRouteWithChildren = WorkspaceRouteRoute._addFileChildren(
  WorkspaceRouteRouteChildren,
);

interface AdminRouteRouteChildren {
  AdminAiOpsRoute: typeof AdminAiOpsRoute;
  AdminIncidentsRoute: typeof AdminIncidentsRoute;
  AdminMoneyRoute: typeof AdminMoneyRoute;
  AdminOperationsRoute: typeof AdminOperationsRoute;
  AdminSignupsRoute: typeof AdminSignupsRoute;
  AdminUsageRoute: typeof AdminUsageRoute;
  AdminIndexRoute: typeof AdminIndexRoute;
  AdminAccountsUserIdRoute: typeof AdminAccountsUserIdRoute;
  AdminServersNodeRoute: typeof AdminServersNodeRoute;
  AdminTenantsWorkspaceIdRoute: typeof AdminTenantsWorkspaceIdRoute;
  AdminAccountsIndexRoute: typeof AdminAccountsIndexRoute;
  AdminServersIndexRoute: typeof AdminServersIndexRoute;
  AdminTenantsIndexRoute: typeof AdminTenantsIndexRoute;
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminAiOpsRoute: AdminAiOpsRoute,
  AdminIncidentsRoute: AdminIncidentsRoute,
  AdminMoneyRoute: AdminMoneyRoute,
  AdminOperationsRoute: AdminOperationsRoute,
  AdminSignupsRoute: AdminSignupsRoute,
  AdminUsageRoute: AdminUsageRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminAccountsUserIdRoute: AdminAccountsUserIdRoute,
  AdminServersNodeRoute: AdminServersNodeRoute,
  AdminTenantsWorkspaceIdRoute: AdminTenantsWorkspaceIdRoute,
  AdminAccountsIndexRoute: AdminAccountsIndexRoute,
  AdminServersIndexRoute: AdminServersIndexRoute,
  AdminTenantsIndexRoute: AdminTenantsIndexRoute,
};

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  WorkspaceRouteRoute: WorkspaceRouteRouteWithChildren,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  DesignRoute: DesignRoute,
  DeviceRoute: DeviceRoute,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  ApproveApprovalIdRoute: ApproveApprovalIdRoute,
  BadgeProjectRoute: BadgeProjectRoute,
  DbAccessGrantIdRoute: DbAccessGrantIdRoute,
  GithubCallbackRoute: GithubCallbackRoute,
  InvitationsAcceptRoute: InvitationsAcceptRoute,
  InviteCodeRoute: InviteCodeRoute,
  WaitlistConfirmRoute: WaitlistConfirmRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
